import { getValueError } from "../../payments/data";
import { IData } from "./types";

export const initData: IData = {
  name: getValueError(""),
  mobile: getValueError(""),
  email: getValueError(""),
};
